import { SagaIterator } from "redux-saga";
import { call, select, takeLatest } from "typed-redux-saga";
import { AnyAction } from "redux";
import { Action } from "typescript-fsa";

import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";

import { deleteXFinanzDatei } from "../../../utilities/rpcHelper";
import { ModulfDataSelectors } from "../../../utilities/selectors/modulfDataSelectors";
import { RESOURCE_KEYS } from "../../../localization";
import { putErrorNotification } from "../../../utilities/notificationUtils";
import { DELETE_XFINANZ_DATEI } from "../../../utilities/variables/customEventNames";
import { executeWithoutValidation } from "../../../utilities/validationUtils";
import { PATH_TO_FILE_ATTACHMENT_LOCATION } from "../../../utilities/variables/modulfRuntimeAnnotations";
import { executeBusy, reloadTaskAndAntragActivity } from "../../../utilities/workflowUtils";
import { ModulfUiSelectors } from "../../../utilities/selectors/modulfUiSelectors";

const XFINANZ_KEYS = RESOURCE_KEYS.features.xFinanzDatei;

export function* deleteXFinanzDateiSaga(): SagaIterator<void> {
	yield* takeLatest(
		(action: AnyAction) => {
			return (
				FormEngineActions.event.match(action) &&
				Events.eventButton.match(action.payload.engineEvent) &&
				[DELETE_XFINANZ_DATEI].includes(action.payload.engineEvent.payload.name)
			);
		},
		function* (action: Action<FormEngineActions.FormEngineEventActions<Action<Events.EventButtonPayload>>>) {
			yield* call(executeBusy, function* () {
				const { activityId } = action.payload;
				yield* call(executeWithoutValidation, activityId, function* () {
					const { buttonPath } = action.payload.engineEvent.payload;
					const annotations = yield* select(
						ModulfUiSelectors.selectButtonAnnotations(activityId, buttonPath)
					);

					let pathToFileAttachments = annotations.find(
						it => it.name === PATH_TO_FILE_ATTACHMENT_LOCATION
					)?.value;
					pathToFileAttachments = pathToFileAttachments?.substring(pathToFileAttachments?.indexOf("/root/"));

					const data = yield* select(ModulfDataSelectors.selectTaskDocument(activityId));

					if (!(pathToFileAttachments && data)) {
						yield* call(
							putErrorNotification,
							{ key: XFINANZ_KEYS.error.deleteError },
							{},
							activityId,
							"xFinanzDatei"
						);
						return;
					}

					try {
						yield* call(deleteXFinanzDatei, data.id, pathToFileAttachments);
						yield* call(reloadTaskAndAntragActivity);
					} catch (error) {
						yield* call(
							putErrorNotification,
							{ key: XFINANZ_KEYS.error.deleteError },
							{},
							activityId,
							"xFinanzDatei"
						);
					}
				});
			});
		}
	);
}
